export default __webpack_public_path__ + "assets/b72df85ede0c4d330f161910fb24e1e6/roommate-finder.png";